import Analytics from 'analytics';
//import hubSpotPlugin from '@analytics/hubspot';
import googleAnalytics from '@analytics/google-analytics';
import { stripHtml } from "string-strip-html";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import dayjs from 'dayjs';
import { Archive, Trash3, InfoCircleFill, Search, ThreeDots, ChevronLeft, Plus, XCircle } from 'react-bootstrap-icons';
import { datadogRum } from '@datadog/browser-rum';

import CONSTANTS from './constants';
import withExpiry from './withExpiry';

const utils = {

    analytics: null,

    datadog : null,
    getHTML : (fieldObj) => {
        return { __html: fieldObj }
    },


    // JEST TEST ADDED and passing
    replaceTokensInField : (cmField, dataForReplace) => {
        let formattedData = cmField;

        if(cmField.indexOf('{{') > -1) {
            //replace {{fieldValName}} with actual data by that name
            formattedData = cmField.replace(/{{(.*?)}}/g, (match, p1) => {
                return dataForReplace[p1] || '';
            });
        }


        return formattedData;
    },
    
    // JEST TEST ADDED and passing
    returnNeededApps: (appsList, removeList) => {
        let neededApps = [];
        appsList.forEach((app) => {
            if (app.fields && app.fields.apptype && !removeList.includes(app.fields.apptype)) {
                neededApps.push(app);
            }
        });
        return neededApps;
    },

    // JEST TEST ADDED and passing
    appAllowedForUser: (app, userApps) => {
        const apptype = app.fields.apptype?.toLowerCase();
        const customctalink = app.fields.customctalink?.toLowerCase();
        if (apptype === 'dynamic' && customctalink) {
            return userApps.includes(`dynamic/${customctalink}`);
        }
        return userApps.includes(apptype) || Boolean(customctalink && userApps.includes(customctalink));
    },

    // JEST TEST ADDED and passing
    replaceTokensInFilter : (cmField, dataForReplace) => {

        if (!cmField) return cmField;

        let formattedData = cmField;

        if(cmField.indexOf('**') > -1) {
            //replace {{fieldValName}} with actual data by that name
            formattedData = cmField.replace(/\*\*(.*?)\*\*/g, (match, p1) => {
                return dataForReplace[p1] || '';
            });

            let dataVal = formattedData.split(',')

            if (dataVal.length > 1 ) {
                return dataVal
            } else {
                return dataVal[0];
            }
        }
        return formattedData;
    },


    // JEST TEST ADDED and passing
    capitalCasing: (str) => {
        if (isNaN(str) && str&& str.length > 0 && (!str.includes('@') || !str.includes('.com'))) {
            let theTitleArray = str.split('');
            let capitaledFirstLetter = theTitleArray[0].toUpperCase();
            let restOfString = theTitleArray.slice(1, theTitleArray.length)
            let capitalizedString = `${capitaledFirstLetter}${restOfString.join('')}`
     
            return capitalizedString;
        } else {
            return str;
        }
    },


    // JEST TEST ADDED and passing
    subscriptOptArr : (userSettings) => {

        if (!userSettings || !userSettings.tenant || !userSettings.tenant.fields || !userSettings.tenant.fields.apps) {
            return [];
        }

        let subscriptionsArr = [];

        userSettings.tenant.fields.apps.forEach((app) => {
            if(app.fields.apptype === 'news' || app.fields.apptype === 'intelligence') {
                subscriptionsArr.push(app.fields.apptype);
            }
        })
        return subscriptionsArr;
    },

    // JEST TEST ADDED and passing
    isInArray : (item, arrayToLookIn) => {
        if (!arrayToLookIn || arrayToLookIn.length < 1  || !item) {
            return -1;
        }

        const targetLower = typeof item.target === 'string' ? item.target.toLowerCase() : String(item.target || '').toLowerCase();
        
        
        return arrayToLookIn.findIndex( (thisItem) => {
            return thisItem.target.toLowerCase() === targetLower && thisItem.for.toLowerCase() === item.for.toLowerCase();
        });
    },

    // IGNORING JEST TEST - (Used in Super Admin only - will be deprecated soon)
    filterWkspcListToWrkspc: (wrkspcs, itemToLookupVal, attrtolookup) => {
        //workspaceList that comes from get-tenants-list
        let fndWrkspc = wrkspcs.filter( (thisWkspc) => {
            return thisWkspc[attrtolookup].toLowerCase() === itemToLookupVal.toLowerCase();
        });

        if(fndWrkspc.length > 0) {
            return fndWrkspc[0];
        }

        return {};
    },

    // JEST TEST ADDED and passing
    addTagSubscriptionToArray : (e, beMap, subItem, cpyPrefs) => {

        let whatBox = beMap[e.target.name];
        let isChecked = e.target.checked;
        let copy = [...cpyPrefs]

        let newSub = { type: 'tag', for: whatBox, target: subItem.toLowerCase()};

        let alreadyIn = utils.isInArray(newSub, copy);
        
        if(isChecked) {
            //if checked = on, add to our state by name
            if(alreadyIn < 0) {
                copy = [...copy, newSub]
            }
        } else {
            //if checked = off, remove from our state by name
            if(alreadyIn > -1) {
                copy.splice(newSub, 1);
            }
        }
        return copy;
    },


    // JEST TEST ADDED and passing
    getFeatureflags : (serverLoc, featureType, flags) => {

        if (!flags || flags.length < 1 || !featureType || featureType === '' || !serverLoc || serverLoc === '') {
            return "false";
        }

        let sevLoc = serverLoc === 'DEV' ? 'onForDevelopment' : 'onForProduction';
        let retVal = 'false';
        
        for( let i=0; i < flags.length; i++ ) {
            if(flags[i].fields && flags[i].fields.flagKey && flags[i].fields.flagKey === featureType) {
                retVal = flags[i].fields[sevLoc];
            }
        }
        return retVal;
    },


    // JEST TEST ADDED and passing
    getTagsArray: (tagsList) => {
        if (!tagsList || !Array.isArray(tagsList)) return []; 
    
        return tagsList.map(tag => {
            if (typeof tag === "string") {
                return tag;  // string for lb_search format
            } else if (tag?.fields?.tagtext) {
                return tag.fields.tagtext;  // object format for cms-content format
            }
            return "";  
        });
    },

//----- No JEST TEST ADDED for below functions since they interact with localStorage -----
    setForceTenantValue : ( newValue ) => {
        //use localstorage to save the forcevalue
        localStorage.setItem('forceTenantID', newValue);
    },

    removeForceTenantValue : () => {
        localStorage.removeItem('forceTenantID');
    },

    getForceTenantValue : () => {
        //get the tenID if exists, returns null if not set
        return localStorage.getItem('forceTenantID');
    },
// ----- 

    // JEST TEST ADDED and passing
    //this function takes in a url and looks to see if the template link exists and if so replaces it with the right url
    removeURLPlaceholder: (link, type) => {
        if (type === 'news') {
            return link.replace(/{{news_page_link}}/g, 'workspace.linksbridge.com/news/')
        } 
        if (type === 'topics') {
            return link.replace(/{{topic_page_link}}/g, 'workspace.linksbridge.com/topics/')
        }
    },

    // JEST TEST ADDED and passing
    convertTagForURL: (tag) => {
        if (tag && tag.length > 0) {
             let sterilizedQuery = JSON.stringify({ query: tag });
            let encodedQuery = encodeURIComponent(sterilizedQuery);
            return encodedQuery;
        }
    },

    // JEST TEST ADDED and passing
    limitTags : (tagsList, term) => {
        // make copy of state list
        let copyList = [...tagsList]
 
        if(term) {
            // Convert to string in order to lower case array values
            let convertToStrToLowerCase = copyList.toString().toLowerCase();
            // Convert back to an array
            let convertToArr = convertToStrToLowerCase.split(',');

            if (convertToArr.includes(term.toLowerCase())) {
                // Find the index of the tag that is being searched for
                let idxOfTag = convertToArr.indexOf(term.toLowerCase());
                // Remove the tag from its current position
                let [tagToMove] = copyList.splice(idxOfTag, 1);
                // Add the tag to be the first value in the array
                copyList.unshift(tagToMove);
                return copyList.slice(0,5);
            } 
        }
        // shorten the taglist to be only the first 5 tags
        copyList = copyList.slice(0,5);
        return copyList;
    },
    
    // JEST TEST ADDED and passing
    findURLPath : (apps, urlPath) => {
        if (!urlPath) return undefined;
        
        if (urlPath.includes('irc_app')) {
            urlPath = urlPath.split('/')[0];
        }
        if(apps) {
            let pathToReturn;
            for (let i = 0; i < apps.length; i ++){
                if (apps[i].fields.apptype === urlPath) {
                    if(apps[i].fields.customctalink) {
                        pathToReturn = apps[i].fields.customctalink;
                    } 
                    else if(apps[i].fields.customCTALinkName) {
                        pathToReturn = apps[i].fields.customCTALinkName;
                    }
                    else {
                        pathToReturn = apps[i].fields.apptype;
                    }
                    return pathToReturn.toString();
                }
            }
        }
    
    },

    // JEST TEST ADDED and passing
    findUserInfo: (tenUserID, membersList) => {
        if (tenUserID && membersList && membersList.length > 0) {
            let user = membersList.filter((member) => {
                return member.id === tenUserID;
              })
              return user;
        }
        return [];
    },

    // JEST TEST ADDED and passing
    getUserEmailPrefs: async (token) => {

        let response =  await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${token.user.sub}/preferences`, {
            headers: {
                "Authorization": "Bearer " + token.accessToken
            }
        });

        let res = await response.json();
        return res;
    },

    // JEST TEST ADDED and passing
    saveUserEmailPrefs: async (prefToUpdate, token) => {
        let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${token.user.sub}/preferences`, {
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + token.accessToken
            },
            body: JSON.stringify(prefToUpdate)
        });
        let res = await response.json();
        return res;
    },

    // JEST TEST ADDED and passing
    deleteUserEmailPrefs: async (userPrefs, token) => {
        let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${token.user.sub}/preferences`, {
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer " + token.accessToken
            },
            body: JSON.stringify(userPrefs)
        });
        let res = await response.json();
        return res;
    },

    // JEST TEST ADDED and passing
    getAppName: (appKey) => {
        if(CONSTANTS.APPNAMES_BY_PATH.hasOwnProperty(appKey.toLowerCase())){
            return CONSTANTS.APPNAMES_BY_PATH[appKey.toLowerCase()];
        }
        if(CONSTANTS.APPS_BY_NAME.hasOwnProperty(appKey.toUpperCase())){
            return CONSTANTS.APPS_BY_NAME[appKey.toUpperCase()];
        }

        return null;
    },

    // JEST TEST ADDED and passing
    // looks up tagtext (case-insensitive) in CONSTANTS.TAG_TEXT_OVERRIDES, returns override or original value if no match
getPreferredTagText: (tagText) => {
        if (!tagText || typeof tagText !== 'string') return tagText;
        const key = tagText.toLowerCase();
        return CONSTANTS.TAG_TEXT_OVERRIDES?.[key] ?? tagText;
    },


    // JEST TEST ADDED and passing
    getAccessToken: async (getAccessTokenSilently, user) => {
        const setUserInfo = (userInfo) => {
            datadogRum.setUser({
                id: userInfo?.sub, // User ID
                email: userInfo?.email, // User email
                name: userInfo?.name // User name
            });
        };

        try{
            let theAccToken = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "read:current_user"
                }
            });
            setUserInfo(user);            

            return { accessToken: theAccToken, user: user };
        } catch(error) {
            console.error('Error getting access token:', error);
            return null;
        }
    },

    // JEST TEST ADDED and passing
    isSuperAdmin: (userEmail, saList) => {
        if (!userEmail || !Array.isArray(saList)) return false;
        return saList.findIndex((sa) => {
            const adminEmail = sa.adminEmail || (sa.fields && sa.fields.adminEmail);
            return adminEmail && userEmail.toLowerCase() === adminEmail.toLowerCase();
        }) > -1;
    },

    // JEST TEST ADDED and passing
    isAUserManager : (tnt, userAcct) => {
        if(tnt && tnt.fields && tnt.fields.userManagers) {
            let isMgr = tnt.fields.userManagers.findIndex( (thisTnt) => { return userAcct && userAcct.email ? thisTnt.fields.emailAddress.toLowerCase().indexOf(userAcct.email.toLowerCase()) > -1 : false } );
      
            return isMgr > -1;
        }

        return false;
        
    },


    // JEST TEST ADDED and passing
    getSubNavLinkName: (fullName) => {
        switch (fullName) {
            case 'Capability Analysis By Company':
                return 'By Company';
            case 'Capability Analysis Summary':
                return 'Summary';
            default:
              return fullName;
        }  
    },

    // JEST TEST ADDED and passing
    getTenantContent: async (token, app, userCGs, uid, extraParams) => {
        let addedParams = '';

        if(extraParams && extraParams.length > 0) {
            addedParams = `&${extraParams}`;
        }

       
        //use the app fields test list
        if(process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.toLowerCase() === 'dev') {
            addedParams = addedParams + '&use_test_list=true';
        }

        let response = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/workspace-content?app=${app}&userCGs=${userCGs}&uid=${uid}${addedParams}`, {
            headers: {
                "Authorization": "Bearer " + token.accessToken,
                "Content-Type": "application/json"
            }
        });

        let jsonResp = await response.json();
        return jsonResp;
    },

    // JEST TEST ADDED and passing
    replaceFieldValueFromName : (fieldsDisplayed, fieldName) => {
        // Defensive: fieldName must be a non-empty string
        if (typeof fieldName !== 'string' || fieldName.trim().length < 1) {
            return '';
        }
        //only continue if field exists in fields list with the appropriate field name

        //create a map of lowerCase field names to the actual field name
        // Defensive: fieldsDisplayed must be an object
        let fields = (fieldsDisplayed && typeof fieldsDisplayed === 'object')
            ? (fieldsDisplayed.fields ? fieldsDisplayed.fields : fieldsDisplayed)
            : {};
       
        if (!fields || typeof fields !== 'object') {
            return '';
        }

        // Defensive: fields may not be a plain object (could be a primitive)
        let keys;
        try {
            keys = Object.keys(fields);
        } catch (e) {
            return '';
        }
        let fieldsList = keys.reduce((acc, thisField) => {
            acc[String(thisField).toLowerCase()] = thisField;
            return acc;
        }, {});

        // If the field name is not in the list, return empty string
        const lowerFieldName = fieldName.toLowerCase();
        if (!fieldsList.hasOwnProperty(lowerFieldName)) {
            return '';
        }

        return fields[fieldsList[lowerFieldName]];

    },

    initializeTracking: function(){
        this.analytics = Analytics({
            app: 'Linksbridge Platform',
            version: 100,
            plugins: [
              googleAnalytics({
                trackingId: 'UA-128191977-2',
              }),
            //   hubSpotPlugin({
            //     portalId: '8615684'
            //   })
            ]
          });
        datadogRum.init({
            applicationId: 'ad1866e0-6c73-4190-8051-ebfea7b76516',
            clientToken: 'pub24cb8c082751427b4ccd9df3fc214a61',
            // `site` refers to the Datadog site parameter of your organization
            // see https://docs.datadoghq.com/getting_started/site/
            site: 'us5.datadoghq.com',
            service: 'user-monitoring',
            env: process.env.REACT_APP_ENV || 'DEV',
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'allow',
            beforeSend: (event) => {
                if (event.type === 'error' && event.error?.message?.includes('ResizeObserver loop')) {
                    return false;
                }
            },
          });
          this.datadog = true
    },
    
    // initializeGA: () => {
    //     ReactGA.initialize('UA-128191977-2');
    // },

    gaPageView: function(pageName){
        // ReactGA.pageview(pageName);
        if (this.analytics) {
            this.analytics.page({
                title: pageName, // The title of the page
                path: window.location.pathname, // The current page path
                url: window.location.href, // The full URL of the page
            });
        } else {
            console.log("Analytics not initialized");
        }
    },

    gaEvent: function( eventObj ) {
        // ReactGA.event({       
        //     category: eventObj.categoryName,  // Required
        //     action: eventObj.eventName,       // Required
        //     label: eventObj.label,       
        //     ...eventObj     
        // });
        this.analytics.track(eventObj.categoryName, {
            action: eventObj.eventName,
            ...eventObj
        });
    },

    setTrackingForWorkspace: function( workspaceName ) {  
        if(this.datadog && workspaceName && workspaceName !== '') { 
            datadogRum.setGlobalContextProperty("workspace", workspaceName);
        }
    },

    logError: (error, context = {}) => {
        const err = error instanceof Error ? error : new Error(String(error));
        datadogRum.addError(err, context);
    },

    // JEST TEST ADDED and passing
    trackAppView: async (appName, tenID, userToken) => {
        //does a post to logging service with token 
        // body: { forApp: appName, tenID: tenantID }

        //first, let's see if they have accessed this app within the last 5 min, 
        //if so, don't send tracking
        // if not, make the call and set the expiring item

        let identifierKey = tenID.toLowerCase() + '-' + appName.toLowerCase();
        let isFound = withExpiry.getWithExpiry(identifierKey); //returns null if not found

        if(isFound === null) {
            await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/logs/signins`, {
                method: 'POST',
                headers: {
                    Authorization: userToken.accessToken ? userToken.accessToken : userToken
                },
                body: JSON.stringify({
                    forApp: appName,
                    tenID: tenID
                 })
            });

            withExpiry.setWithExpiry(identifierKey, 'tracked', 5*60*1000 ); //5 min in ms
        }
    },
    
    
    // JEST TEST ADDED and passing
    getPreviewTextFromHTML: function( fieldToConvert, numChar ) {
        const safeInput = typeof fieldToConvert === 'string' ? fieldToConvert : (fieldToConvert == null ? '' : String(fieldToConvert));
        let strippedText = stripHtml(safeInput).result;
        if(strippedText.length > numChar ) {
            return strippedText.substr(0,numChar) + '...'
        }

        return strippedText;
    },

    // JEST TEST ADDED and passing
    // Convert options into array format for LBSelect
    getOptionsArray: (list, valueField = null, labelField = null) => {
        // ensure list is an array
        if (!Array.isArray(list)) return [];
        // Use Set to avoid duplicates
        return [...new Set(list)].map((item) => {
            if (typeof item === 'string' || typeof item === 'number') {
                return { label: item.toString(), value: item };
            }
            return {
                label: labelField ? item[labelField] : (item.label || item.toString()),
                value: valueField ? item[valueField] : (item.value || item)
            };
        });
    },

    // JEST TEST ADDED and passing - Legacy function for backward compatibility - Convert options into object format for CheckBoxDropDownSelector
    getOptionsObj: (list, selected) => {
        // ensure list is an array
        if (!Array.isArray(list)) return {};
        // ensure selected is an array
        const safeSelected = Array.isArray(selected) ? selected : [];
        let retObj = {};
        // Use Set to avoid duplicate keys
        [...new Set(list)].forEach((key) => {
            retObj[key] = safeSelected.includes(key);
        });
        return retObj;
    },

    // JEST TEST ADDED and passing
    // Legacy function for CheckBoxDropDown compatibility
    handleSelectAllCheckboxDropdownSelection: (event, selected, fullList, selectAll) => {
        //ensure event and event.target exist
        if (!event || !event.target || typeof event.target.value !== 'string' || typeof event.target.id !== 'string') {
            return { updatedSelection: [], updatedSelectAll: [] };
        }
        //ensure variables are arrays
        const safeSelected = Array.isArray(selected) ? selected : [];
        const safeFullList = Array.isArray(fullList) ? fullList : [];
        let updatedSelectAll = Array.isArray(selectAll) ? [...selectAll] : [];

        const value = event.target.value;
        let updatedSelection = [];

        if (value === "select-all") {
            if (updatedSelectAll.includes(event.target.id)) {
                updatedSelection = [];
                updatedSelectAll = updatedSelectAll.filter(item => item !== event.target.id);
            } else {
                updatedSelection = [...safeFullList];
                updatedSelectAll = [...updatedSelectAll, event.target.id];
            }
        } else {
            updatedSelectAll = [];
            if (safeSelected.includes(value)) {
                updatedSelection = safeSelected.filter(item => item !== value);
            } else {
                updatedSelection = [...safeSelected, value];
            }
        }
        return { updatedSelection, updatedSelectAll };
    },

    // JEST TEST ADDED and passing
    getIndexOfValueInArrayOfObjectsByProp: function(propName, value, listToCheck) {
        //listToCheck must be a non-empty array
        if (!Array.isArray(listToCheck) || listToCheck.length < 1) {
            return undefined;
        }
        const lenListToCheck = listToCheck.length;
        for(let i=0; i<lenListToCheck; i++) {
            if (listToCheck[i] && typeof listToCheck[i] === 'object' && propName in listToCheck[i] && listToCheck[i][propName] === value) {
                return i;
            }
        }

        //iterated through the list and didn't see it
        return undefined;
    },

    // JEST TEST ADDED and passing
    filterToDateRange: function(list, dateFieldName, range) {
        if (!Array.isArray(list)) return [];
        let backDate = new Date();
        backDate.setHours(backDate.getHours()-range);

        return list.filter( (thisItem) => {
            // skip items without a fields object
            if (!thisItem || typeof thisItem.fields !== 'object' || thisItem.fields === null) return false;
            return new Date(thisItem.fields.dateFieldName) > backDate;
        })
    },

    // JEST TEST ADDED and passing
    filterToCountry: function(list, countryFieldName) {
        // ensure list is an array and search term is a string
        if (!Array.isArray(list) || typeof countryFieldName !== 'string') return [];
        return list.filter( (thisItem) => {
            if(thisItem.fields.headquartersCountry) {
                return thisItem.fields.headquartersCountry.toLowerCase().trim().indexOf(countryFieldName.toLowerCase().trim()) > -1;
            } else {
                return false;
            }
        })
    },

    // JEST TEST ADDED and passing
    filterToCompanyType: function(list, companyType) {
        // ensure list is an array and search term is a string
        if (!Array.isArray(list) || typeof companyType !== 'string') return [];
        return list.filter((thisItem) => {
            if (thisItem.fields.companyType) {
                return thisItem.fields.companyType.toLowerCase().trim().indexOf(companyType.toLowerCase().trim()) > -1;
            } else {
                return false;
            }
        })
    },

    // JEST TEST ADDED and passing
    tagTracker: async (tagToSend) => {
        await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/tag-tracking?tag=${tagToSend}`);
    },

    // JEST TEST ADDED and passing
    addFilters: function(existingFilter, filterVal) {
        if(existingFilter !== '') {
            filterVal = existingFilter + ',' + filterVal;
            return filterVal;
        } else {
            filterVal = '&filters=' + filterVal;
            return filterVal;
        }
    },

    // JEST TEST ADDED and passing
    getValueOfCurrentFilterByFilterName: function (list, nameOfFilter) {

        let pickedFilter = list.filter( (listItem) => {
            return listItem.name.toLowerCase().indexOf(nameOfFilter.toLowerCase()) > -1;
        });

        if(pickedFilter.length > 0) {
            return pickedFilter[0].value;
        } else {
            return undefined;
        }

    },

    // JEST TEST ADDED and passing
    addTargetToLinksInHtml: function(linkFields) { 
        //this function takes our "links" field from agility, and puts a 'target="_blank" in each
        return linkFields.replace(/<a href=/g, '<a target="_blank" rel="noreferrer" href=');
    },

    // JEST TEST ADDED and passing
    getAPIKey: async (token) => {
         const response = await fetch(process.env.REACT_APP_B2C_DB_API_KEY_URL_V2, {
             headers: { Authorization: `Bearer ${token.accessToken}` },
         });
         const { value } = await response.json();
         return value;
     },
 
     // JEST TEST ADDED and passing
     getAppNavItems: async (endpoint, app, token, apiKey, isProd=false) => {
         let params =`?app_key=${app}&token=${token}&is_prod=${isProd}`;
         const response = await utils.getData(endpoint, apiKey, params);
         return response.appFields;
     },

     // JEST TEST ADDED and passing
     orderNavItems: (navList) => {
 
         const sortedNavDescr = [...navList].sort((a, b) => {
             const groupOrderA = a.groupOrder !== null ? a.groupOrder : Infinity; // Treat null as the lowest priority
             const groupOrderB = b.groupOrder !== null ? b.groupOrder : Infinity;
             return groupOrderA - groupOrderB;    
         });
 
         // Sort the subNav array within each navGroup by orderOfDisplay
         sortedNavDescr.forEach((navGroup) => {
             if (navGroup.subNav && Array.isArray(navGroup.subNav)) {
                 navGroup.subNav.sort((a, b) => {
                     const orderA = a.orderOfDisplay !== null ? a.orderOfDisplay : Infinity; // Treat null as the lowest priority
                     const orderB = b.orderOfDisplay !== null ? b.orderOfDisplay : Infinity;
                     return orderA - orderB;
                 });
             }
         });
 
         return sortedNavDescr;
     },

    // JEST TEST ADDED and passing
    cleanUpNavs: function (navs, profile) {

        let useNavs = [];

        //check each field at nav level, take off nav obj if no object in profile - helper functions
        const getPageItemsWithContent = (pageItemsArray, profile) => {
            let retArray = [];
            pageItemsArray.forEach( (thisPItem) => {
                if( thisPItem.fieldAPIName === 'news' || thisPItem.fieldAPIName === 'ircNews' ||
                    (profile.fields[thisPItem.fieldAPIName] && 
                        (profile.fields[thisPItem.fieldAPIName] !== '' && profile.fields[thisPItem.fieldAPIName] !== null)) ) {
                    retArray.push(thisPItem);
                }
            });

            return retArray;
        };

        const getSubNavsWithContent = (subNavArray, profile) => {
            let retArray = [];
            
            //get a subNav array
            subNavArray.forEach( (thisItem) =>{
                let tempObj = {...thisItem, pageItems: getPageItemsWithContent(thisItem.pageItems, profile)}
                if(tempObj.pageItems.length > 0) {
                    retArray.push(tempObj);
                }
            });
    
            return retArray;
        };

        if(navs && navs.length > 0) {
            navs.forEach( (thisNavItem) => {
                let tempObj = {};
                tempObj = {...thisNavItem, subNav: getSubNavsWithContent(thisNavItem.subNav, profile)};
                if(tempObj.subNav.length > 0){
                    useNavs.push(tempObj);
                }
            });
        }

        return useNavs;

    },

        // JEST TEST ADDED and passing
        submitIntelligenceRequest: async (action, reportID, accessToken, report, tenID) => {
            let method = 'PUT';
            let bodyToSend;

            if (action.toLowerCase() === "delete") {
                method = 'DELETE';
                bodyToSend = {
                    contentID: reportID
                }
            } else if (action === 'ARCHIVED' || action === 'APPROVE') {
                //updates the form.archive state - toggles to current val
                bodyToSend = utils.updateArchiveState(action, report);
            } else {
                bodyToSend = {
                    contentID: reportID
                }
            }

            const tenidParam = tenID ? `?tenid=${tenID}` : '';
            await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/cms-content/intelligence/${reportID}${tenidParam}`, {
                headers: {
                    "Authorization": "Bearer " + accessToken.accessToken,
                    "Content-Type": "application/json"
                },
                method: method,
                body: JSON.stringify(bodyToSend)
            })
        
        },
      
    //toggles intervention form.archive state
    updateArchiveState: (action, temp) => {
        let tempArchive = temp.archived === 'true' ? 'false' : 'true';
      
        if (action === 'ARCHIVED') {
          temp.archived =  tempArchive;
        }

        if (action === 'APPROVE') {
          temp.approved = 'true';
        }
        return temp;
    },

    // JEST TEST ADDED and passing
    getPageOfResults: function( originalList, pageNumber, numberInPage ) {
        let startOfSlice = (pageNumber-1) * numberInPage;
        let endOfSlice = startOfSlice + numberInPage;
        let slicedList = originalList.slice(startOfSlice, endOfSlice);
        return slicedList;
    }, 
    
    // JEST TEST ADDED and passing
    convertDashDateStringToMonthDayYear : (dateStr) => {
        const longMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (!dateStr) {
            return null;
        }
        let dateArr = dateStr.split('-');
        if (
            dateArr.length !== 3 ||
            isNaN(parseInt(dateArr[0])) ||
            isNaN(parseInt(dateArr[1])) ||
            isNaN(parseInt(dateArr[2]))
        ) {
            return null;
        }
        const year = dateArr[0];
        const monthIndex = parseInt(dateArr[1], 10) - 1;
        const day = dateArr[2];
        if (monthIndex < 0 || monthIndex > 11) {
            return null;
        }
        return `${longMonthNames[monthIndex]} ${day}, ${year}`;
    },

    //Displays date in yyyy-mm-dd format
    // JEST TEST ADDED and passing
    getDashDateString : (dateStr) => {
        if(!dateStr){
            return null
        }
        let dateArr = dateStr.split('/')
        return `${dateArr[2]}-${dateArr[0] && (parseInt(dateArr[0]) < 10) ? '0' + dateArr[0]: dateArr[0]}-${dateArr[1]}`
    },

    //Depending on desired format displays date string
    // JEST TEST ADDED and passing
    getDateString : (dateStr, format, subFormat=null) => {
        const longMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let datePcs;
        let mnthShown;

        //formats new date()
        if(format === 'newDate' || format === 'newDateDash') {
            let dateArr = dateStr.toString().split(' ')

            for (let i = 0; i < shortMonthNames.length; i++) {
                if (shortMonthNames[i] === dateArr[1]) {
                    if (format === 'newDateDash') {
                        //formats for days 1-9 and adds a 0
                        if (i < 9) {
                        
                            return `${dateArr[3]}-0${i + 1}-${dateArr[2]}`
                        } else {
                            //fomats for days 10-31
                            return `${dateArr[3]}-${i + 1}-${dateArr[2]}`
                        }  
                    }
                    //formats for days 1-9 and adds a 0
                    if (i < 9) {
                        return `0${i + 1}/${dateArr[2]}/${dateArr[3]}`
                    } else {
                        //fomats for days 10-31
                        return `${i + 1}/${dateArr[2]}/${dateArr[3]}`
                    }
                }
            }
        } else {

            let cutDate = dateStr.split('T')[0];
            datePcs = cutDate.split('-');
            mnthShown = parseInt(datePcs[1]);
            //Displays long month format January 05, 2023
            if(subFormat && subFormat === 'without-day') {
                return `${longMonthNames[mnthShown-1]} ${datePcs[0]}`
            }
            if(format === 'long') {
                return `${longMonthNames[mnthShown-1]} ${datePcs[2]}, ${datePcs[0]}`;
            } 
            //diplays short month format Jan 05, 2023
            if(format === 'short') {
                return `${shortMonthNames[mnthShown-1]} ${datePcs[2]}, ${datePcs[0]}`;
            } 
            //displays long DD Month YYYY
            if (format === 'long-day-first') {
                return `${datePcs[2]} ${longMonthNames[mnthShown-1]}, ${datePcs[0]}`
            }
            //Diplays yyyy/mm/dd
            return `${datePcs[1]}/${datePcs[2]}/${datePcs[0]}`;
        }

    },

    // JEST TEST ADDED and passing
    formatDateForPicker: (dtToFormat) => {
        let dtDate;

        if(typeof(dtToFormat) === 'string' || typeof(dtToFormat) === 'number') {
            dtDate = new Date(dtToFormat);
        
        } else {    
            dtDate = dtToFormat;
        }
        
        if(!isNaN(dtDate)) {
            let year = dtDate.getFullYear();
            let mon = dtDate.getMonth()+1;
            let dy = dtDate.getDate();

            if(mon < 10) {
                mon = '0' + mon;
            }

            if(dy < 10) {
                dy = '0' + dy;
            }

            return `${year}-${mon}-${dy}`
        }
        

        return '';
    },

    //market actions related stuff
    // JEST TEST ADDED and passing
    setMembersListBasedOnMarketName: (memberList, existAssigneesList, marketname, shouldFilter=true, ten) => {

        const market_names_for_LB_users = ['test market'];

        const filterOutLBUsers = (list) => {

            //filter the linksbridge / sassenach / linksbridgedevtest users 
            return list.filter( (thisItem) => {
                const mailOrEmail = thisItem.mail || thisItem.email;
                return mailOrEmail &&
                        mailOrEmail.toLowerCase().indexOf('@linksbridge.com') < 0 &&
                        mailOrEmail.toLowerCase().indexOf('@sassenach.co') < 0 &&
                        mailOrEmail.toLowerCase().indexOf('@linksbridgedevtest.onmicrosoft.com') < 0
            });
        };

        //put the assignees into an array of simple strings, taking out null users, and sort by alpha
        let assigneesRaw = memberList.filter((item) => {
            return item !== null;
            }).map((thisPerson) => {
            return thisPerson;
            }).sort();


        let assignees = Array.from(new Set(assigneesRaw.concat(existAssigneesList)));

        if(market_names_for_LB_users.indexOf(marketname) < 0 && shouldFilter === true) {
            if(ten.fields.tenantslug === 'LB-Level-Q') {
                return assigneesRaw;
            }
            return filterOutLBUsers(assignees);
        }

        return assignees;

    },

    // JEST TEST ADDED and passing
    snakeToTitleCase: function(s){
        return s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
         .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()) // First char after each -/_
    },
    

    // JEST TEST ADDED and passing
    getData: async function (endPoint, apiKey, query){

        const headers= {
            'Content-Type': 'application/json',
            'access_token': apiKey
        }
        try{
            const result = await fetch(process.env.REACT_APP_DB_API_URL+endPoint+
                (query!==undefined?query:''), 
                {headers:headers})
            if (result['status'] === 403) {
                return "Invalid API key, access denied"
            }
            return result.json()

        } catch(error){
            return "Failed to fetch data. Please contact an administrator";
        }
        
    },
    
    // JEST TEST ADDED and passing
    delete: async function (endPoint, apiKey, data){

        const headers = {
            'Content-Type': 'application/json',
            'access_token': apiKey
        }
        const requestOptions = {
          method: 'DELETE',
          headers:headers,
          body: JSON.stringify(data)
        }
        let result = await fetch(process.env.REACT_APP_DB_API_URL+endPoint, requestOptions)
        let resultJson = await result.json()
        if (result['status'] === 403 ) {
          return "Invalid API key, access denied"
        }
        if (result['status'] === 422) {
          // Basic response parsing for known errors, so far only duplicate key errors
          if (resultJson['detail'].includes("not allow nulls")){
            return "There is a field in this record that should not be null"
          }else if (JSON.stringify(resultJson['detail']).includes("is not a valid")){
            return "There is an incorrect type in a field"
          }else{
            // Fall back case. Try to get the user to send the detailed error report.
            return "Unable to delete for an unknown reason"
          }
        }
        return resultJson
    },


    // JEST TEST ADDED and passing
    db_api_post: async function (endPoint, apiKey, data){
        try{
            const headers = {
                'Content-Type': 'application/json',
                'access_token': apiKey
            }
            const requestOptions = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(data)
            }
            let result = await fetch(process.env.REACT_APP_DB_API_URL + endPoint, requestOptions)
            let resultJson = await result.json()

            if (result['status'] === 403) {
                return {error: "Invalid API key, access denied"}
            }
            if (result['status'] === 422) {
                // Basic response parsing for known errors, so far only duplicate key errors
                if (resultJson['detail'].includes("duplicate key")) {
                    return {error: "This record already exists in the database. Please find and update that record."}
                }
                else if (resultJson['detail'].includes("not allow nulls")) {
                    return {error: "There is a field in this record that should not be null"}
                } else if (JSON.stringify(resultJson['detail']).includes("is not a valid")) {
                    return {error: "There is an incorrect type in a field"}
                } else {
                    // Fall back case. Try to get the user to send the detailed error report.
                    return {error: "Unable to create or update for an unknown reason"}
                }
            }
            if (result['status'] === 404){
                return {error: 'The requested resource was not found. Please check the endpoint or contact an administrator.'}
            }
            if (result['status'] === 500){
                return {error: 'An unexpected error occurred, this update may result in duplicate records. Please contact an admistrator or open a ticket'}
            }
            if (result['status'] !== 200 && result['status'] !== 201) {
                return {error: "An unexpected error occurred, please contact an administrator or open a ticket"}
            }
            return resultJson
        }catch (error) {
            return {error: "Unknown issue adding or creating data"}
        }
    },

    // JEST TEST ADDED and passing
    isMNCTenant: (tenantSetting) => {
        return tenantSetting.tenant.fields.hasOwnProperty('isMNC') && tenantSetting.tenant.fields.isMNC === "true";
    },

    // JEST TEST ADDED and passing
    getDefaultEyesChecked : (tenant) => {
        let returnObj = {};
        let tempArr;
        
        if (tenant.tenant.fields.tenantslug === "LB-Level-Q") {
            tempArr = Object.values(CONSTANTS.TENANT_SLUG_TO_EYES);
        } else {
            tempArr = CONSTANTS.EYES_FOR_TENANT_VIEW[tenant.tenant.fields.tenantslug];
        }
        tempArr.forEach( (thisEye) => {
          returnObj[thisEye] = 'on';
        });
        return returnObj;
    },
    
    // JEST TEST ADDED and passing
    convertInfoOwnerNumberToSlug: (infoOwner, listOfSlugs) => {
        let returnKey = Object.keys(listOfSlugs).filter( (thisKey) => {
            return listOfSlugs[thisKey].toString() === infoOwner.toString();
        });

        return returnKey.length > 0 ? returnKey[0] : undefined;
    },

    // JEST TEST ADDED and passing
    createStrSortOrder: function(a, b){
        if (a.toLowerCase() < b.toLowerCase()){
          return -1;
        } else if (a.toLowerCase() > b.toLowerCase()){
          return 1;
        } else {
          return 0;
        }
    },

    getIcon: (type, className = null) => {
        let classToAdd = className || '';

        return (
            type === 'delete' ?
                <Trash3 className={`btn-icon ${classToAdd}`} />
                :
                type === 'archive' ?
                    <Archive className={`btn-icon ${classToAdd}`} />
                    :
                    type === 'search' ?
                        <Search className={`btn-icon ${classToAdd}`} />
                        :
                        type === 'three-dots' ?
                            <ThreeDots className={`btn-icon ${classToAdd}`} />
                            :

                            type === 'chevron-left' ?
                                <ChevronLeft className={`btn-icon ${classToAdd}`} />
                                :
                                type === 'plus' ?
                                    <Plus className={`btn-icon ${classToAdd}`} />
                                    :
                                    type === 'xCircle' ?
                                        <XCircle className={`btn-icon ${classToAdd}`} />
                                        : ''
        )
    },

    getTitle : (title) => {
        return (
            <>
              <InfoCircleFill className=' m-b-end-02 svg-16'/>{title}
            </>
        )
    },

    // JEST TEST ADDED and passing
    filterOutUnneeded: (navlist) => {
        let navsToSend = navlist.filter((navItem) => navItem.groupingTitle !== "--")
        return navsToSend;
    },

    // JEST TEST ADDED and passing
    getDefaultView: (navlist, defaultPage) => {

        let findIfDefaultExists = navlist.filter( (thisItem) => {
          return thisItem.urlForField === defaultPage;
        });
    
        if(findIfDefaultExists && findIfDefaultExists.length > 0) {
          return defaultPage
        } else {
          return navlist[0].subNav[0].urlForField;
        }
    },

    // JEST TEST ADDED and passing
    makeOrdinal: function(n){
        // Convert from a number, say 1, to the ordinal version "1st"
        const nStr = String(n)
        // Handle the non-conforming cases
        if ([11,12,13].includes(n)){
          return nStr+'th'
        }
        // Handle the standards for st, nd, and rd
        if (nStr.charAt(0) === '1'){
            return nStr+'st'
        }
        if (nStr.charAt(0) === '2'){
            return nStr+'nd'
        }
        if (nStr.charAt(0)==='3'){
            return nStr+'rd'
        }
        return nStr+'th'
      },

    // JEST TEST ADDED and passing
    numberWithCommas: function(x) {
        // Handle the falsies
        if (!x){
            return null
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
    // JEST TEST ADDED and passing
    exportExcel(theData, baseFileName){
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
          const fileName=baseFileName+dayjs(new Date()).format('YYYYMMDD')
          if(!theData){
              return
          }
          const ws = XLSX.utils.json_to_sheet(theData);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, fileName + fileExtension);
      },
    

    // Utility function to format numbers with commas for display
    formatNumberWithCommas: (number) => {

        if (number === null || number === undefined) {
        return '';
        }
        return number.toLocaleString();
    },
    // fetches all the enums at once so that get_enums is not called multiple times per table row.
    // currently used in PMT Market Actions and Demand Health
    // JEST TEST ADDED and passing
    fetchEnums: async (apiKey, enumTypes = []) => {
        try {
            const fetchEnumPromises = enumTypes.map((type) =>
                utils.getData('get_enums', apiKey, `?enum_type=${type}&include_deleted=true`)
            );
            const responses = await Promise.all(fetchEnumPromises);
            return enumTypes.reduce((acc, type, index) => {
                acc[type] = responses[index].map((item) => ({
                    label: item.enum,
                    value: item.enum,
                }));
                return acc;
            }, {});
        } catch (error) {
            console.error('Error fetching enums:', error);
            throw error;
        }
    },

    normalizeEyes: (val) => {
        if (val === true || val === 'true' || val === 'on') {
            return 'on';
        }
        return 'off';
    },

    // JEST TEST ADDED and passing
    getFormattedIntelligenceData: (data, tenant) => {
        let formattedForm = {
            // normalized eyes
            bmgfEyes: utils.normalizeEyes(data.bmgf_eyes),
            cepiEyes: utils.normalizeEyes(data.cepi_eyes),
            chaiEyes: utils.normalizeEyes(data.chai_eyes),
            gaviEyes: utils.normalizeEyes(data.gavi_eyes),
            unicefEyes: utils.normalizeEyes(data.unicef_eyes),
            whoEyes: utils.normalizeEyes(data.who_eyes),
            pahoEyes: utils.normalizeEyes(data.paho_eyes),
            linksbridgeEyes: utils.normalizeEyes(data.linksbridge_eyes),
            // other fields
            approved: data.approved ?? 'false',
            archived: data.archived ?? 'false',
            attachedImageList: data.attached_image_list || '',
            attachedRefFileList: data.attached_ref_file_list || '',
            contentID: data.contentid ?? null,
            credibility: data.credibility || '',
            reportDate: data.datePublished || null,
            displayBody: data.display_body || '',
            id: data.id || '',
            keyContact: data.key_contact || '',
            reporter: data.reporter || '',
            reportType: data.report_type || '',
            sensitivity: data.sensitivity || '',
            source: data.source || "",
            sourceLink: data.source_link ?? '',
            sourceType: data.source_type || '',
            tags: Array.isArray(data.tags) ? data.tags.join(', ') : data.tags || '',
            title: data.title || '',
            informationOwner: data.information_owner || tenant.tenant.fields.functionalInformationOwner,
            reliability: data.reliability || '',
            sourceDate: data.source_date || new Date().toISOString(),
        }
        return formattedForm;
    },

    // JEST TEST ADDED and passing
    addbackgroundClass: (row, configType) => {
        
        if (configType === 'USERLIST_SETTINGS_CONFIG' || configType === 'GLOBAL_USERLIST_SETTINGS_CONFIG') {
            return !row.migrated || row.migrated === false ? 'surface-secondary-light' : 'surface-primary-light';
        }
        return '';
    },
}

export default utils
